import { ENTITY_LIMIT_TYPE as COLLECTION_ENTITY_LIMIT_TYPE } from '@jira/polaris__domain-collection/src/entityLimitType.constants.tsx';
import { ENTITY_LIMIT_TYPE as PROJECT_ENTITY_LIMIT_TYPE } from '@jira/polaris__domain-project/src/entityLimitType.constants.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { EntityLimitType, EntityLimits } from './EntityLimitType.types.tsx';
import type {
	EntityLimitsResponse,
	EntityLimitsResponseType,
} from './EntityLimitsResponse.types.tsx';

const ENTITY_LIMIT_TYPE = { ...PROJECT_ENTITY_LIMIT_TYPE, ...COLLECTION_ENTITY_LIMIT_TYPE };

export const fetchEntityLimits = async (): Promise<EntityLimits> => {
	const entityLimits: EntityLimits = {};

	const response = await fetchJson<EntityLimitsResponse>(
		fg('jpd_use_gravity_limits')
			? '/gateway/api/jpd/gravity/v1/limits'
			: '/gateway/api/polaris/rest/limits',
	);

	// Convert the response to the format expected by the UI
	for (const [key, value] of Object.entries(response?.limits ?? {})) {
		// oxlint-disable-next-line typescript/consistent-type-assertions
		const limitType: EntityLimitType = ENTITY_LIMIT_TYPE[key as EntityLimitsResponseType];
		if (limitType) {
			entityLimits[limitType] = value;
		}
	}

	return entityLimits;
};
